import React, { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { Cabin } from '../types/cabin';
interface CabinModalProps {
  cabin: Cabin | null;
  onClose: () => void;
}
export function CabinModal({
  cabin,
  onClose
}: CabinModalProps) {
  useEffect(() => {
    if (!cabin) return;
    document.body.style.overflow = 'hidden';
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [cabin, onClose]);
  const whatsappHref = cabin ? `https://wa.me/573244688664?text=${encodeURIComponent(`Hola! Me interesa la cabaña ${cabin.name} en Refugio Caracolí.`)}` : '#';
  return <AnimatePresence data-id="element-39" data-mp="2gnh5wizgb8hq">
      {cabin && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.4
    }} onClick={e => {
      if (e.target === e.currentTarget) onClose();
    }} className="fixed inset-0 bg-black/90 backdrop-blur-md z-[2000] flex items-center justify-center p-4 sm:p-6" role="dialog" aria-modal="true" data-id="element-40" data-mp="2gmfm9q4dddoe">
          <motion.div initial={{
        opacity: 0,
        y: 25,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 25,
        scale: 0.96
      }} transition={{
        duration: 0.4,
        ease: [0.25, 0.46, 0.45, 0.94]
      }} className="bg-night-2 rounded-[40px] max-w-3xl w-full max-h-[88vh] overflow-y-auto border border-white/[0.07]" data-id="element-41" data-mp="yhvqjb5u3hum">
            <div className="relative h-56 sm:h-80 lg:h-[360px] overflow-hidden rounded-t-[40px]" data-id="element-42" data-mp="frdzrc4kawbw">
              <img src={cabin.image} alt={cabin.name} className="w-full h-full object-cover" data-id="element-43" data-mp="kqh6d106xalz" />
              <div className="absolute inset-0 bg-gradient-to-t from-night-2 to-transparent" data-id="element-44" data-mp="ko4ffycgfpws" />
              <button onClick={onClose} aria-label="Cerrar" className="absolute top-5 right-5 w-9 h-9 bg-black/55 backdrop-blur-sm border border-white/20 rounded-full flex items-center justify-center text-white transition-transform duration-300 hover:bg-white/20 hover:rotate-90" data-id="element-45" data-mp="cnev9os4yy0w">
                <XIcon className="w-4 h-4" data-id="element-46" data-mp="3pvjflhkbwffs" />
              </button>
            </div>
            <div className="p-6 sm:p-10" data-id="element-47" data-mp="3lv7te0cbi727">
              <h3 className="font-display text-3xl font-light text-white mb-1" data-id="element-48" data-mp="3lwako9djybin">{cabin.name}</h3>
              <p className="text-xs text-gold tracking-[0.15em] uppercase mb-5" data-id="element-49" data-mp="3qo2bl8vrzaj">{cabin.modalCaption}</p>
              <p className="text-sm text-white/60 leading-loose mb-7" data-id="element-50" data-mp="3uttbxvhshm2z">{cabin.modalDescription}</p>
              <div className="flex flex-wrap gap-2.5 mb-8" data-id="element-51" data-mp="1f2oz9nfweu1d">
                {cabin.amenities.map(a => <span key={a} className="bg-white/10 border border-white/[0.18] text-white/80 px-3.5 py-1.5 rounded-full text-xs" data-id="element-52" data-mp="1a4x2af0echqb">
                    {a}
                  </span>)}
              </div>
              <a href={whatsappHref} target="_blank" rel="noopener noreferrer" className="w-full flex items-center justify-center gap-2.5 bg-gradient-to-br from-gold to-gold-light text-night py-4 px-8 rounded-full text-sm font-bold tracking-wide uppercase transition-transform duration-300 hover:-translate-y-0.5 hover:shadow-[0_12px_35px_rgba(201,169,110,0.45)]" data-id="element-53" data-mp="2wzil6q3jwqhk">
                Consultar Disponibilidad por WhatsApp
              </a>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}